angular.module('impactx.rfx').controller('RFXListOffersCtrl', [
    '$scope',
    '$redirect',
    'selectedListItems',
    '$routeParams',
    'TranslationService',
    'ConfirmationService',
    'dataGen',
    'ToastService',
    '$route',
    'RFXBuyerService',
    RFXListOffersCtrl]);

function RFXListOffersCtrl($scope, $redirect, selectedListItems, $routeParams, TranslationService, ConfirmationService, dataGen, ToastService, $route, RFXBuyerService) {
    var self = this;

    var buttonDefinition = [
        {
            label: "details",
            linkFunction: getDetailLink,
            type: 'link',
            condition: canViewOffer,
            process: 'RFXView'
        },
        {
            label: "edit",
            linkFunction: getEditOfferLink,
            type: 'link',
            condition: canEditOffer,
            process: 'RFXSupplierEditForBuyer'
        },
        {
            label: "reject",
            action: reject,
            type: 'dialogaction',
            condition: canRejectOffer,
            process: 'RFXSupplierEditForBuyer'
        }
    ];

    self.meta = {
        rowTemplate: 'modules/rfx/templates/rfx-list-offers.row.tmpl.html',
        isSelectAble: true,
        ctrl: this,
        endpoint: '/rfx/list/offers',
        id: "rfxlistoffers",
        buttonDefinition: buttonDefinition,
        valuesInteger: [{name: "RFQH_Id", value: $routeParams.rfqhId}],
    };

    self.getMeta = function () {
        return this.meta;
    };

    function getDetailLink() {
        return "rfx/offer/" + selectedListItems.getFirstSelectedId();
    }

    function getEditOfferLink() {
        return "rfxsuppliereditbuyer/" + $routeParams.rfqhId + "/" + selectedListItems.getFirstSelectedId();
    }

    function canViewOffer() {
        var firstSelectedItem = selectedListItems.getFirstSelectedItem();
        return selectedListItems.isSingleSelection && firstSelectedItem && firstSelectedItem.canViewOffer.value;
    }

    function canEditOffer() {
        var firstSelectedItem = selectedListItems.getFirstSelectedItem();
        return selectedListItems.isSingleSelection && firstSelectedItem && firstSelectedItem.canEditOffer.value;
    }

    function canRejectOffer() {
        if (selectedListItems.isMultiSelection()) {
            return selectedListItems.getSelectedItems().some(function (item) {
                return item.canRejectOffer.value;
            });
        }
        return false;
    }


    function rejectInternal() {
        dataGen.postAsForm({}, {ids: selectedListItems.getSelectedIds()}, "/rfx/buyer/rejectOffers").then(function () {
            ToastService.openStandardToast(TranslationService.get('saveSuccess'));
            $route.reload();
        });
    }

    function reject(event, trns) {
        ConfirmationService.showConfirmationDialog(function () {
            if (selectedListItems.getFirstSelectedItem().useTextCustomization.value) {
                RFXBuyerService.showTextCustomization(event, 0, RFXBuyerService.STATUS.CANCELLED, selectedListItems.getSelectedIds()).then(function (result) {
                    if (result && result.send) {
                        rejectInternal();
                    }
                });
            }
            else {
                rejectInternal();
            }
        }, event, trns.rejectOfferQuestion, trns.reject, TranslationService.get('abort'));
    };
}